import * as React from 'react'
import { Link } from "react-router-dom";
import './Foot.css';

function Foot() {
  return (
    <React.Fragment>
        <div className="contact-info footer-component">
                <div className="title">
                    <div className="logo-contact">
                            <Link to='/mis-procesos' id="logoContact" className="material-icons-round no-link">
                                <img id="logo" src={require('../Media/rollin_white_logo_and_name.png')} alt="rollin logo and name" />
                            </Link>
                    </div>
                </div>
                <div className="footer-component">
                    <div className="data">
                        <div className="wrapper icono">
                            <span className="material-icons-round contact">mail</span> 
                        </div>
                        <div className="wrapper dataContact">info@rollin.lat</div>
                    </div>
                    <div className="data">
                        <div className="wrapper icono">
                            <span className="material-icons-round contact">phone</span> 
                        </div>
                        <div className="wrapper dataContact">+57 319 691 74 60</div>
                    </div>
                </div>
                <div className="media">
                    <a href="/" className="fa fa-linkedin"> </a>
                    <a href="/" className="fa fa-twitter"> </a>  
                    <a href="/" className="fa fa-instagram"> </a>
                    <a href="/" className="fa fa-facebook"> </a>
                </div>
            </div>
            <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
    </React.Fragment>
  );
}

export { Foot };
